import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthenticationGuardService } from './services/authentication/authentication-guard.service';
import { RootRedirectorComponent } from './root-redirector/root-redirector.component';

const routes: Routes = [
  { path: 'admin', loadChildren: 'app/pages/pages.module#PagesModule', canActivate: [AuthenticationGuardService] },
  { path: 'auth', loadChildren: 'app/pages/auth/auth.module#AuthModule' },
  { path: '', component: RootRedirectorComponent, pathMatch: 'full' },
  { path: '**', redirectTo: 'admin' },
];

const config: ExtraOptions = {
  useHash: false,
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
